// import TweenMax from 'gsap';
// import ScrollMagic from 'scrollmagic';

var controller;

function eventScrollSM() {
    controller = new ScrollMagic.Controller();

    // set trigger pinned and duration scroll
    const getHeightBroswer = $(window).height();

    //add class autonumber to pinned
    $(".scrollmagics").each(function (i) {
        $(this).addClass("pin-scrollmagics-" + i);
    });

    //add class autonumber to pinned
    $(".content-scrollmagic").each(function (i) {
        $(this).addClass("pin-content-scrollmagic-" + i);
    });

    //add class autonumber to pinned
    $(".freeze-bg").each(function (i) {
        $(this).addClass("pin-freeze-bg-" + i);
    });

    // find each element BACKGROUND to add scene
    var revealScrollMagic = document.getElementsByClassName("freeze-bg");
    for (var i = 0; i < revealScrollMagic.length; i++) {
        //add height inline
        $(".pin-content-scrollmagic-" + [i]).css(
            "height",
            $(".pin-scrollmagics-" + [i]).innerHeight() + 625
        );

        new ScrollMagic.Scene({
            triggerElement: ".pin-scrollmagics-" + [i],
            duration:
                $(".pin-scrollmagics-" + [i]).innerHeight() +
                625 -
                getHeightBroswer,
            triggerHook: "onLeave",
        })
            .setPin(".pin-freeze-bg-" + [i], {
                pushFollowers: false,
            })
            .addTo(controller);
    }
    // end set trigger pinned and duration scroll

    //add class autonumber to pinned
    $(".flying").each(function (i) {
        $(this).addClass("pin-flying-" + i);
    });

    //add class autonumber to pinned and toogle
    $(".bg-changes").each(function (i) {
        $(this).addClass("pin-bg-changes-" + i);
    });

    // find each element TEXTBOX to add scene
    var revealElements = document.getElementsByClassName("flying");
    for (var i = 0; i < revealElements.length; i++) {
        if ($(window).width() >= 768) {
            //for caption dekstop
            new ScrollMagic.Scene({
                triggerElement: ".pin-flying-" + [i],
                duration: $(".pin-flying-" + [i]).innerHeight(),
                triggerHook: "0.1",
            })
                .setClassToggle(".pin-bg-changes-" + [i] + " .caption", "show")
                .addTo(controller);
        } else {
            //for caption mobile
            new ScrollMagic.Scene({
                triggerElement: ".pin-flying-" + [i],
                duration: $(".pin-flying-" + [i]).innerHeight(),
                triggerHook: "0.1",
            })
                .setClassToggle(".pin-bg-changes-" + [i] + " .caption", "open")
                .addTo(controller);
        }

        //for bg
        new ScrollMagic.Scene({
            triggerElement: ".pin-flying-" + [i],
            //duration: $('.pin-flying-'+[i]).innerHeight(), //dont use if we want last child keep the class toggle
            triggerHook: "0.1",
        })
            .setClassToggle(".pin-bg-changes-" + [i], "show-me")
            .on("start", function (event) {
                $(".bg-changes.show-me").each(function () {
                    $(this).find("video").get(0).currentTime = 0;
                    if(event.scrollDirection !== `REVERSE`) {
                        $(this).find("video").get(0).play();
                    }
                });

                // console.log(event);
            })
            .on("update", function (e) {
                if ($(window).width() >= 768) {
                    $(".bg-changes .caption").removeClass("open");
                }
            })
            .on("leave", function (event) {
                $(".bg-changes").not('.show-me').each(function () {
                    $(this).find("video").get(0).pause();
                    $(this).find("video").get(0).currentTime = 0;
                });
            })
            .addTo(controller);
    }
}

function fadeMe() {
    $(".freeze-bg .bg-changes").css({
        WebkitTransition: "opacity 1s ease-in-out",
        MozTransition: "opacity 1s ease-in-out",
        MsTransition: "opacity 1s ease-in-out",
        OTransition: "opacity 1s ease-in-out",
        transition: "opacity 1s ease-in-out",
    });
}

function fadeUnset() {
    $(".freeze-bg .bg-changes").css({
        WebkitTransition: "unset",
        MozTransition: "unset",
        MsTransition: "unset",
        OTransition: "unset",
        transition: "unset",
    });
}

$(function () {
    var windowWidth = $(window).width();
    var windowHeight = $(window).height();

    //check mobile or dekstop element
    if (windowWidth <= 767) {
        $(".s-magic-desktop").remove();
    } else {
        $(".s-magic-mobile").remove();
    }

    //call scrollmagic
    eventScrollSM();

    //set default fade
    fadeMe();

    // Resize Event
    $(window).resize(function () {
        //$(window).off('scroll');

        // Check window width has actually changed and it's not just iOS triggering a resize event on scroll
        if (
            $(window).height() != windowHeight ||
            $(window).width() != windowWidth
        ) {
            // Update the window width for next time
            windowHeight = $(window).height();
            windowWidth = $(window).width();

            // Do stuff here
            fadeUnset();

            //set it back to fade
            setTimeout(function () {
                fadeMe();
            }, 2000);
        }

        // Otherwise do nothing
        controller.destroy(true); //reset scrollmagic
        eventScrollSM(); //call scrollmagic
    });
    if($(window).width() > 768) {
        $(".bg-changes").each(function () {
            const videoId = $(this).find("video").attr('id');
            // console.log(videoId);
    
            var video = document.getElementById(videoId);
    
            video.addEventListener("play", function() {
                $('.replay[video-id="'+ videoId +'"').addClass('hidden');
            }, false);
    
            video.addEventListener("ended", function() {
                $('.replay[video-id="'+ videoId +'"').removeClass('hidden');
            }, false);
        });
    }


    $('body').on('click', '.replay', function () {
        const videoId = $(this).attr('video-id');
        
        var video = document.getElementById(videoId);
        
        video.play();
    });


});

$(function () {
    $(window).on("scroll", function (event) {
        if($(window).width() <= 768) {
            $('#scrollmagic-mobile .item').each(function (index, element) {
                const videoId = $(this).find('video').attr('id');
                const video = document.getElementById(videoId);

                const initTopPosition= $(this).offset().top;   
                const initBottomPosition= $(this).outerHeight() + initTopPosition;   
                if($(window).scrollTop() > initTopPosition && $(window).scrollTop() < initBottomPosition) {
                    video.play();
                    // console.log('video.play');
                }
                else {
                    video.pause();
                    video.currentTime = 0;
                }
            });
        }
    });
    
    if($(window).width() <= 768) {
        $("#scrollmagic-mobile").find('.item').each(function () {
            const videoId = $(this).find("video").attr('id');
            // console.log(videoId);
    
            var video = document.getElementById(videoId);
    
            video.addEventListener("play", function() {
                $('.replay[video-id="'+ videoId +'"').addClass('hidden');
            }, false);
    
            video.addEventListener("ended", function() {
                $('.replay[video-id="'+ videoId +'"').removeClass('hidden');
            }, false);
        });
    }

});